import { ItemList } from '../../orm'

class AdminChangeMollieSubscription extends ItemList {
    getEntityKey() {
        return "admin/mollie_subscription/reschedule"
    }
}

export const adminChangeMollieSubscription = new AdminChangeMollieSubscription("admin_change_mollie_subscription__default")
